import React, { useEffect, useRef, useState } from "react";
import { Loader2, VideoOff, Volume2, VolumeX } from "lucide-react";

export default function VideoTile({ stream, muted = false, label, badges, searching, placeholder, audioControls, fit = "cover", bare = false, cornerLabel }) {
  const ref = useRef(null);
  const [vol, setVol] = useState(1);
  const [muteRemote, setMuteRemote] = useState(false);
  const showBar = !bare && !!(label || badges || (audioControls && stream));

  useEffect(() => {
    if (ref.current && stream) ref.current.srcObject = stream;
  }, [stream]);

  useEffect(() => {
    if (ref.current && !muted) {
      ref.current.volume = vol;
      ref.current.muted = muteRemote;
    }
  }, [vol, muteRemote, muted, stream]);

  return (
    <div className="flex flex-col w-full h-full rounded-xl overflow-hidden border border-border bg-black" onContextMenu={(e) => e.preventDefault()}>
      {showBar && (
        <div className="shrink-0 flex items-center justify-between gap-2 px-3 py-1.5 bg-[#161616] border-b border-border">
          <div className="flex items-center gap-1.5 min-w-0 flex-wrap">
            {label && <span className="text-sm font-semibold">{label}</span>}
            {badges}
          </div>
          {audioControls && stream && (
            <div className="flex items-center gap-2 shrink-0">
              <button onClick={() => setMuteRemote((m) => !m)} data-testid="partner-mute-btn" className="text-foreground hover:text-primary transition-colors">
                {muteRemote || vol === 0 ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
              </button>
              <input
                type="range" min="0" max="1" step="0.05" value={muteRemote ? 0 : vol}
                onChange={(e) => { setVol(parseFloat(e.target.value)); setMuteRemote(false); }}
                data-testid="partner-volume-slider"
                className="w-24 accent-purple-500 cursor-pointer"
              />
            </div>
          )}
        </div>
      )}

      <div className="relative flex-1 min-h-0 bg-black">
        {cornerLabel && (
          <span className="absolute bottom-2 left-2 z-20 px-2 py-0.5 rounded-md text-xs font-medium glass border border-border">{cornerLabel}</span>
        )}
        {stream ? (
          <video ref={ref} autoPlay playsInline muted={muted} className={`w-full h-full bg-black ${fit === "contain" ? "object-contain" : "object-cover"}`} data-testid={`video-${label || "tile"}`} />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-muted-foreground gap-3 bg-[#0d0d0d]">
            {searching ? (
              <>
                <div className="relative flex items-center justify-center w-16 h-16">
                  <span className="absolute inset-0 rounded-full brand-gradient-bg opacity-30 pulse-ring" />
                  <Loader2 className="w-10 h-10 animate-spin text-primary relative" />
                </div>
                <span className="text-sm">Looking for someone…</span>
              </>
            ) : (
              <>
                <VideoOff className="w-10 h-10 opacity-40" />
                <span className="text-sm">{placeholder || "No video"}</span>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
